import { db } from "common/config/Firebase"
import addTaskToTicketDetail from "./detail/addTaskToTicketDetail"
import BusEvent from "common/services/BusEvent"

const ticketsCollection = db.collection('tickets')

const addTicketUseCase = async (ticket) => {
    const { id } = await ticketsCollection.add({
        ...ticket,
        ticketDate: new Date().getTime()
    })

    if (ticket.newTask) {
        await addTaskToTicketDetail(ticket, ticket.ivaPercent, ticket.taskReference)
        ticket.newTask = false
    }

    BusEvent.publish(BusEvent.NEW_TICKET, ticket)

    return id
}

export default addTicketUseCase